import { render } from "./SectionTechBackend.vue?vue&type=template&id=15c6c99f&scoped=true"
import script from "./SectionTechBackend.vue?vue&type=script&lang=js"
export * from "./SectionTechBackend.vue?vue&type=script&lang=js"

import "./SectionTechBackend.vue?vue&type=style&index=0&id=15c6c99f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15c6c99f"]])

export default __exports__